import { FC, useCallback } from 'react';
import { useField } from 'react-final-form';

import { FieldSkeleton } from '../FieldSkeleton/FieldSkeleton';

import { TownSelect, TownSelectItem, TownSelectProps } from './TownSelect';

export interface FormTownSelectProps
  extends Omit<TownSelectProps, 'town' | 'onChange'> {
  name: string;
  onChange?: (value: TownSelectItem | undefined) => void;
  loading?: boolean;
}

export const FormTownSelect: FC<FormTownSelectProps> = ({
  name,
  required,
  onChange,
  loading,
  ...rest
}) => {
  const validate = useCallback(
    (value: TownSelectItem | undefined) => {
      if (required && value === undefined) return 'Заполните поле';

      return '';
    },
    [required],
  );

  const { input, meta } = useField(name, { type: 'string', validate });
  const error = meta.touched ? meta.error : undefined;

  const handleChange = useCallback(
    (value: TownSelectItem | undefined) => {
      input.onChange(value);
      onChange?.(value);
    },
    [input, onChange],
  );

  return loading ? (
    <FieldSkeleton />
  ) : (
    <TownSelect
      town={input.value}
      {...rest}
      required={required}
      error={!!error}
      helperText={error}
      onChange={handleChange}
    />
  );
};
